<!--
 * @Description: 资源单条查找带回
 * @Author: PF
 * @Date: 2023-10-26 10:47:38
 * @LastEditors: PF
 * @LastEditTime: 2024-10-08 14:21:14
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="wp80 hp80" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">资源</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header class="mb10 pl0 pr0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-cascader placeholder="资源库" :options="sjzykData" v-model="dataGrid.parms.zykid" :props="{ label: 'zykmc', value: 'id', children: 'children', checkStrictly: true}" :show-all-levels="false" clearable filterable @change="bindTable()"></el-cascader>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="资源类型" v-model="dataGrid.parms.zylxid" clearable filterable @change="bindTable()">
                <el-option v-for="item in zylxData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="资源名称" v-model="dataGrid.parms.zymc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main class="mb10 pl0 pr0">
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" fixed align="center" width="80" />
            <el-table-column label="资源名称" prop="zymc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="资源类型" prop="zylxbt" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="所属专业" prop="zydmmc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="资源库" prop="zykmc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="上传人" prop="scrxm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="上传时间" prop="scsj" width="150" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="savestudent(currentRow=scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer-but">
            <el-button type="info" @click="closeWindow('openDanTiao', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  </div>
</template>
<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { closeWindow, loadList, loadSelect } from '@/api/common'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
import pagination from '@/components/pagination.vue'
import detail from '@/components/jiaozhigong/detail'
const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])
const row = ref()
const openDetail = ref(false)
const currentRow = ref()

const savestudent = () => {
  emits('ReturnData', currentRow.value)
  closeWindow('openDanTiao', emits, false)
}

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'zymc', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.zykid = Array.isArray(dataGrid.value.parms.zykid)
    ? dataGrid.value.parms.zykid[dataGrid.value.parms.zykid.length - 1]
    : dataGrid.value.parms.zykid
  loadList({
    url: '/api/v2/ziyuan/ziyuan/wangluokechengziyuan',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
// 加载 资源类型 下拉框
const zylxData = ref()
// 加载 资源库 下拉框
const sjzykData = ref()
watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      row.value = props.row
      loadSelect({
        url: '/api/v2/ziyuan/ziyuanku/tree',
        data: sjzykData,
        order: 'zykmc',
        sort: 'asc'
      })
      loadZiDianSelect('资源类型', zylxData)
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
</style>
